import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { PagesModule } from 'pages/pages.module';
import { ReferralHubPage } from './referral-hub';

@NgModule({
    declarations: [ReferralHubPage],
    imports: [PagesModule, ComponentsModule]
})
export class ReferralHubPageModule {}
